import { bindPartnerContactModal } from '../features/partnerContactModal.js';

export class PartnersSinglePage {
    static matches() {
        return document.body.classList.contains('single-partenaire')
            || !!document.querySelector('[data-partner-single]');
    }

    init() {
        bindPartnerContactModal();
    }
}
